/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Office_AddressInputs */

const cs_settings_office_address = /** @type {(inputs: Settings_Office_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adresa`)
};

const en_settings_office_address = /** @type {(inputs: Settings_Office_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Address`)
};

/**
* | output |
* | --- |
* | "Address" |
*
* @param {Settings_Office_AddressInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_office_address = /** @type {((inputs?: Settings_Office_AddressInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Office_AddressInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_office_address(inputs)
	return cs_settings_office_address(inputs)
});